import React from 'react';

const About = () => {
    return (
        <div className="min-h-screen bg-white py-16 md:py-24">
            <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
                <h1 className="font-heading text-4xl md:text-5xl font-bold text-[#2C3333] mb-8 text-center uppercase tracking-tight">
                    About Us
                </h1>

                <div className="prose prose-lg max-w-none text-[#4B5563] space-y-8 leading-relaxed">
                    <section>
                        <h2 className="font-heading text-2xl font-semibold text-[#2C3333] mb-4">Welcome to HappyTring</h2>
                        <p>
                            HappyTring is a digital directory platform designed to make it easier for individuals to connect with mental health professionals.
                            We understand that seeking mental health support can feel overwhelming. Finding the right counsellor, therapist, or mental health expert shouldn’t be complicated. Our goal is to simplify that first step.
                        </p>
                    </section>

                    <section>
                        <h2 className="font-heading text-2xl font-semibold text-[#2C3333] mb-4">Who We Are</h2>
                        <p>
                            HappyTring is operated by Deeptrix Technologies Pvt. Ltd., based in Maharashtra, India.
                            We are a technology-driven company focused on building accessible digital platforms that solve real-world problems. With HappyTring, our mission is to bridge the gap between mental health service providers and individuals seeking support.
                        </p>
                    </section>

                    <section>
                        <h2 className="font-heading text-2xl font-semibold text-[#2C3333] mb-4">What We Do (Current MVP Stage)</h2>
                        <p>
                            At its current stage, HappyTring functions strictly as an <strong>online directory platform</strong> for the mental health sector.
                        </p>
                        <ul className="list-disc pl-6 space-y-2 mt-4">
                            <li>A platform for counsellors, therapists, psychologists, psychiatrists, and other mental health professionals to list their services.</li>
                            <li>A searchable directory where users can view professional profiles and contact details.</li>
                            <li>A simple, structured way for help seekers to explore available options in one place.</li>
                        </ul>
                        <p className="mt-4 italic">
                            We do not provide therapy, diagnosis, treatment, or medical advice. We act solely as an information and discovery platform.
                        </p>
                    </section>

                    <section>
                        <h2 className="font-heading text-2xl font-semibold text-[#2C3333] mb-4">Our Vision & Mission</h2>
                        <p>
                            We believe that mental health support should be <strong>accessible, transparent, easy to find</strong>, and less intimidating to approach. Our mission is to reduce friction in discovering mental health professionals and support early intervention by making contact information easily accessible.
                        </p>
                    </section>

                    <section>
                        <h2 className="font-heading text-2xl font-semibold text-[#2C3333] mb-4">Transparency & Responsibility</h2>
                        <p>
                            We are committed to clear communication about our role as a directory platform and protecting user data in accordance with our Privacy Policy. While we strive to provide a useful and reliable directory, users are responsible for independently verifying credentials and making informed decisions.
                        </p>
                    </section>

                    <div className="mt-16 p-8 bg-secondary/30 rounded-2xl border border-secondary">
                        <h3 className="font-heading text-xl font-semibold text-[#2C3333] mb-4">Contact Us</h3>
                        <div className="text-sm space-y-2">
                            <p className="font-medium text-primary">Deeptrix Technologies Pvt. Ltd.</p>
                            <p>502, Shree Sudarshan Building</p>
                            <p>Shree Avenue Complex</p>
                            <p>Mira Road – 401107, Maharashtra, India</p>
                            <p className="pt-2"><strong>Email:</strong> <a href="mailto:happytringdpl@gmail.com" className="text-primary hover:underline">happytringdpl@gmail.com</a></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default About;
